import React, { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const CLIENT_ID = '403961459111-6jtrkd9jbaskf496b7d1b8gtr9vlkck1.apps.googleusercontent.com';
const SCOPES = 'https://www.googleapis.com/auth/drive.file';

const ProductoAgregarPage = () => {
  const { userId } = useParams();
  const { user } = useAuth();
  const [file, setFile] = useState(null);
  const [name, setName] = useState('');
  const [price, setPrice] = useState('');

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleUpload = async (e) => {
    e.preventDefault();

    if (!file || !name || !price) {
      alert('Please select a file first.');
      return;
    }

    const tokenClient = window.google.accounts.oauth2.initTokenClient({
      client_id: CLIENT_ID,
      scope: SCOPES,
      callback: async (tokenResponse) => {
        if (tokenResponse.error) {
          console.error('Token error:', tokenResponse);
          alert('Authorization failed.');
          return;
        }

        const accessToken = tokenResponse.access_token;

        const metadata = {
          name: file.name,
          mimeType: file.type,
        };

        const form = new FormData();
        form.append('metadata', new Blob([JSON.stringify(metadata)], { type: 'application/json' }));
        form.append('file', file);

        try {
          const uploadResponse = await fetch(
            'https://www.googleapis.com/upload/drive/v3/files?uploadType=multipart&fields=id',
            {
              method: 'POST',
              headers: new Headers({ Authorization: `Bearer ${accessToken}` }),
              body: form,
            }
          );

          const uploadData = await uploadResponse.json();
          console.log('Uploaded File ID:', uploadData.id);
          alert('File uploaded successfully!');
          const fileId = uploadData.id;
          console.log('Uploaded File ID:', fileId);
          await fetch(
            `https://www.googleapis.com/drive/v3/files/${fileId}/permissions`,
            {
              method: 'POST',
              headers: {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                role: 'reader',
                type: 'anyone',
              }),
            }
          );
          const imageUrl = `https://drive.google.com/thumbnail?id=${fileId}`;

          alert('Imagen subida correctamente. Agregando producto...');

          // Post to your Laravel API
          const productPayload = {
            name: name,
            price: parseFloat(price),
            Stars: 4,
            Image: imageUrl,
            updated_at: '2025-08-01',
            user_id: user?.id || 9,
            vendor_id: user?.vendor_id || 9,
          };
          const productResponse = await fetch('https://marketluz.com/laravel8/public/api/productos', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(productPayload),
          });

          if (!productResponse.ok) {
            const errorData = await productResponse.json();
            console.error('Product creation failed:', errorData);
            alert('Error al guardar el producto.');
            return;
          }

          const productData = await productResponse.json();
          console.log('Producto creado:', productData);
          alert('Producto agregado exitosamente.');          
          setName('');
          setPrice('');
          setFile(null);          
        } catch (error) {
          console.error('Error uploading or saving:', error);
          alert('Algo salió mal. Revisa la consola.');
        }
      },
    });

    // Trigger token flow
    tokenClient.requestAccessToken ();
  };

  return (
    <div className="container py-5" style={{ fontFamily: "'Poppins', sans-serif" }}>
      <div className="card shadow-sm border-0 rounded-4 p-4">
      <h2 className="text-center mb-4">
        Agrega nuevo producto para {user.vendor_name}
      </h2>
        <div className="mb-3 text-center">
          <Link 
            to="/vendor" 
            className="btn btn-outline-secondary rounded-pill px-4 shadow-sm"
          >
            ← Regresar al menú de opciones
          </Link>
        </div>

      <form onSubmit={handleUpload} className="mt-4" style={{ marginTop: '20px' }}>
        <div  className="mb-3">
          <label>Nombre del producto:</label><br />
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
        </div>

        <div  className="mb-3">
          <label>Precio:</label><br />
          <input
            type="number"
            step="0.01"
            value={price}
            onChange={(e) => setPrice(e.target.value)}
            required
          />
        </div>        
        <div className="mb-3">
          <label>Selecciona una imagen para tu producto</label><br />
          <input type="file" onChange={handleFileChange} className="form-control"/>
        </div>
        <div className="text-center mt-4">
          <button type="submit" disabled={!file || !name || !price} className="btn btn-primary rounded-pill px-5 shadow-sm">Subir Archivo</button>
        </div>
      </form>
      </div>
    </div>
  );
};

export default ProductoAgregarPage;
